// import { Auth } from 'aws-amplify'

const settings = {
  // API: {
  //   endpoints: [{
  //     name: 'api',
  //     endpoint: process.env.VUE_APP_API_BASE_URL, // API のエンドポイント
  //     // API呼び出し時にAuthorization ヘッダーにCognito tokenを付与する
  //     custom_header: async () => {
  //       return {
  //         Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
  //       }
  //     }
  //   }]
  // },
  Auth: {
    region: process.env.VUE_APP_AWS_REGION, // Cognito UserPoolのリージョン
    userPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID, // Cognito UserPool ID
    userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_APPLICATION_ID, // Cognito UserPool のアプリクライアントID
    // OPTIONAL - customized storage object
    storage: window.sessionStorage
  }
}

export default settings
